import React, {Component} from 'react';
import {Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import './UserApps.css';
import Loading from "../../common/Loading/Loading";
import Dropdown from "../../common/Dropdown/Dropdown";
import Checkbox from "../../common/Checkbox/Checkbox";
import ProductService from "../../services/product-service";
import toastr from "toastr";
import ToastOptions from "../../common/toast/toastr-config";
import AuthorizationService from "../../services/authorization-service";


class AddApp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            appMetadata: {},
            productList: [],
            schemas: [],
            tenantList: [],
            newProduct: {roles: [], environments: []},
            updateProduct: this.props.updateProduct,
            newRoles: [],
            newEnvironments: [],
            newAttributes: {},
            editProductSet: false
        };
    }

    /**
     *  Get all possible user products for the product list
     *  If we already have a selected product passed in the props, select it and set it to the state.
     **/
    fetchProducts = async () => {
        const criteria = {
            q: "user"
        }
        const response = await ProductService.getProductsByCriteria(criteria);
        let product = response.products.find(p => p.appName === this.props.updateProduct.name)
        if (product) {
            this.setState({
                productList: response.products,
                newProduct: product
            })
            this.resetSelected()
        } else {
            this.setState({
                productList: response.products
            })
        }
    }

    /**
     * The attributes from metadata are in root product along with roles, name and environments, so we need to extract them and put them into the form
     * name:nameValue, value: actualValue
     */
    getProductAttributes() {
        let newAtts = {}
        Object.keys(this.props.updateProduct).filter(p => !["name", "roles", "environments"].includes(p)).forEach(pi => {
            newAtts[pi] = this.props.updateProduct[pi]
        })
        return newAtts;
    }

    resetSelected() {
        this.setState({
            newRoles: this.getArray(this.props.updateProduct.roles),
            newEnvironments: this.getArray(this.props.updateProduct.environments),
            newTenant: this.props.updateProduct.tenant,
            newAttributes: this.getProductAttributes()
        })
    }

    componentDidMount() {
        this.fetchProducts();
    }

    /**
     * This will be called on the save.  It preps all the data into an object
     * with appMetaData for product name, roles, environments and attributes and submits to the save method in parent
     */
    addProductToUser() {
        let updateAtts = []
        if (this.state.newAttributes) {
            Object.keys(this.state.newAttributes).forEach(newAtt => {
                updateAtts.push({name: newAtt, value: this.state.newAttributes[newAtt]})
            })
        }

        let appMeta = {
            appMetaData: {
                product: this.state.newProduct.appName,
                roles: this.state.newRoles,
                tenant: this.state.newTenant,
                environments: this.state.newEnvironments,
                attributes: updateAtts
            }
        }
        try {
            this.props.saveAction(appMeta);
            console.log(appMeta)
            this.props.cancelAction()
        } catch (error) {
            toastr.options = ToastOptions;
            toastr.error(error.message);
        }
    }

    addRole(role) {
        if (AuthorizationService.canAddRole(this.state.newProduct.appName, role)) {
            let roles = this.modifyArray(this.state.newRoles, role);
            this.setState({
                newRoles: roles
            });
        } else {
            toastr.options = ToastOptions;
            toastr.warning("You are not authorized to add or alter that role.  Please contact an administrator.");
        }
    }

    modifyArray(array, item) {
        let newArray = [...array];
        if (!newArray.includes(item)) {
            newArray.push(item);
        } else {
            newArray = newArray.filter(r => r !== item);
        }
        return newArray;
    }

    addEnvironment(env) {
        let envs = this.modifyArray(this.state.newEnvironments, env);
        this.setState({
            newEnvironments: envs
        })
    }

    /**
     * The attributes are managed in an object rather than an array, it will be converted back to an array at save time.
     * @param e - the event of the change allowing us to get the input value or checked value
     * @param att - the attribute so we can get the name for managing state
     */
    addAttribute(e, att) {
        let attributes = this.state.newAttributes
        if (att.type !== "Boolean") {
            attributes[att.name] = e.target.value
        } else {
            attributes[att.name] = e.target.checked
        }
        this.setState({
            newAttributes: attributes
        })
    }

    /**
     * Helper method to check if the incoming item is defined, if so, return that as an array, else return the empty array
     */
    getArray(item) {
        return item ? item : []
    }

    /**
     * Called with the product is selected from the drop down
     * passes in the name of the selected product, which matches to the full product upbject in the product list and sets
     * the product by which to get roles, tenants, environments, attributes
     */
    selectProduct = (product) => {
        const foundProduct = this.state.productList.find(p => p.name === product);
        if (foundProduct) {

            this.setState({
                newProduct: foundProduct,
                tenantList: this.getArray(foundProduct.tenants)
            });
            this.resetSelected()
        } else {
            this.setState({
                newProduct: {roles: [], environments: []},
                tenantList: []
            });
        }
    }
    /**
     * Select a single tenant value - will only be called from the tenant list if it exists
     */
    selectTenant = (tenant) => {
        this.setState({
            newTenant: tenant
        })
    }

    render() {
        return (
            <div className="user-apps">
                {/* Add Product */}
                <Modal isOpen={this.props.toggleState} size="lg">
                    <ModalHeader toggle={() => {
                        this.props.cancelAction();
                    }}>
                        Add Product
                    </ModalHeader>
                    {!this.state.isDialogLoading &&
                    <ModalBody>
                        <FormGroup className="custom_form" key="product">
                            <span className="product-label">Product</span>
                            {this.props.isEdit && <span> {this.props.updateProduct.name}</span>}
                            {!this.props.isEdit &&
                            <Dropdown
                                options={this.state.productList.map(s => s.name)}
                                changeSelectedOption={this.selectProduct}
                                selectedValue={this.props.isEdit ? this.props.updateProduct.name : this.state.newProduct.name}
                                defaultValue="Select Product"

                            />}

                        </FormGroup>
                        {this.state.tenantList && this.state.tenantList.length > 0 &&
                        <FormGroup className="custom_form">
                            <span className="product-label">Tenant</span>
                            <Dropdown
                                options={this.state.tenantList.map(t => t.name)}
                                changeSelectedOption={this.selectTenant}
                                defaultValue="Select Tenant"
                            />
                        </FormGroup>
                        }
                        <FormGroup className="custom_form" key="attributes">
                            {this.state.newProduct.attributes && this.state.newProduct.attributes.length > 0 &&
                            <span className="product-label">Attributes</span>
                            }
                            {
                                this.state.newProduct.attributes && this.state.newProduct.attributes.map(att => {

                                    if (att.type !== "Boolean")
                                        return (
                                            <div key={att.name}>
                                                <Label for={att.name}>
                                                    {att.name}
                                                </Label>

                                                <Input
                                                    type="Text"
                                                    name={att.name}
                                                    id={att.name}
                                                    placeholder={att.name}
                                                    value={this.state.newAttributes[att.name] ? this.state.newAttributes[att.name] : ""}
                                                    onChange={e => this.addAttribute(e, att)}
                                                    maxLength="20"
                                                    autoComplete="off"
                                                />
                                            </div>)
                                    else return <div key={att.name}>
                                        {<Checkbox
                                            id={`att_${att.name}`}
                                            label={att.name}
                                            isChecked={this.state.newAttributes[att.name] ? this.state.newAttributes[att.name] : false}
                                            handleChange={e => this.addAttribute(e, att)}
                                        />}
                                    </div>

                                })
                            }
                        </FormGroup>

                        <FormGroup className="custom_form">
                            {this.state.newProduct.roles && <span className="product-label">Roles</span>}
                            {this.state.newProduct.roles && this.state.newProduct.roles.map(role => {

                                return (

                                    <div key={`role_${role.name}`}>

                                        <Checkbox
                                            id={`role_${role.name}`}
                                            label={role.name}
                                            isChecked={this.state.newRoles.find(e => e === role.name) !== undefined}
                                            handleChange={() => this.addRole(role.name)}
                                        />
                                        </div>)
                                }
                            )}
                        </FormGroup>
                        {this.state.newProduct.environments && this.state.newProduct.environments.length > 0 &&
                        <FormGroup className="custom_form">
                            <span className="product-label">Environments</span>
                            {this.state.newProduct.environments.map(env => {
                                    return (
                                        <div key={`role_${env.name}`}>
                                            <Checkbox
                                                id={`role_${env.name}`}
                                                label={env.name}
                                                isChecked={this.state.newEnvironments.find(e => e === env.name) !== undefined}
                                                handleChange={() => this.addEnvironment(env.name)}
                                            />
                                        </div>)
                                }
                            )}
                        </FormGroup>
                        }

                    </ModalBody>
                    }
                    {this.state.isDialogLoading &&
                    <ModalBody className="loading-body">
                        <Loading/>
                    </ModalBody>
                    }
                    <ModalFooter>
                        <Button
                            color="btn btn-link"
                            onClick={() => {
                                this.props.cancelAction();
                            }}>Cancel</Button>

                        <Button
                            type="button"
                            className="btn btn-success submit-user-button"
                            onClick={() => {
                                this.addProductToUser();
                            }}
                            disabled={this.state.isDialogLoading}
                        >Save</Button>

                    </ModalFooter>
                </Modal>
            </div>

        )
    }
}

export default AddApp;




// WEBPACK FOOTER //
// ./src/user-profile/components/AddApp.js